import sendUETAddToCartEvent from "analytics/bing/sendUETAddToCartEvent";
import { IAnanlyticsCompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { IVehicle } from "interfaces/session/IVehicle";
import AmpService from "../../analytics/amplitude/amplitudeEvents";
import EnhancedEcommerce, { sendGA4AddToCartEvent, sendGA4RemoveFromCartEvent } from "../enhanced-ecommerce";
import { getPayload } from "./getPayload";
import { trackEvents } from "./trackEvents";
import { TRACKING_EVENT_NAME } from "./tracking.service";

export function sendUpdateCartEvent(product: IAnanlyticsCompactProduct, vehicle: IVehicle) {
  const payload = getPayload(undefined, product, vehicle);
  const { quantity } = product;
  // gtag("event", TRACKING_EVENT_NAME.MODIFY_CART, {
  //   send_to: GTAG_ID,
  //   productLine: payload.productLine,
  //   google_business_vertical: "custom",
  // });
  trackEvents(
    TRACKING_EVENT_NAME.MODIFY_CART,
    "click",
    { product: { ...payload, quantity } },
  );
  if (quantity === 0) {
    EnhancedEcommerce.removeFromCart(product);
    AmpService.removeCartItem(product.sku);
    sendGA4RemoveFromCartEvent(product);
  } else {
    EnhancedEcommerce.addToCart(product);
    sendGA4AddToCartEvent(product);
    sendUETAddToCartEvent(product);
  }
}
